import { render, staticRenderFns } from "./ShowData.vue?vue&type=template&id=57847628&scoped=true"
import script from "./ShowData.vue?vue&type=script&lang=js"
export * from "./ShowData.vue?vue&type=script&lang=js"
import style0 from "./ShowData.vue?vue&type=style&index=0&id=57847628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57847628",
  null
  
)

export default component.exports